
import { all } from 'redux-saga/effects';
import adminSaga from './adminSaga';
import proposalSaga from './proposalSaga';
import referenceSaga from './referenceSaga';
import authSaga from './authSaga';

export default function* rootSaga() {
    yield all([
        adminSaga(),
        proposalSaga(),
        referenceSaga(),
        authSaga(),
    ]);
}
                